module.exports = __webpack_public_path__ + "bg.no1.1740db6b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/aoyama/child_to_parent/bg.no1.jpg
// module id = ronb
// module chunks = 0